module.exports = __webpack_public_path__ + "img/pieceOnEarth.9fae7288.jpg";